module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap addr-wrap flex-column"
  }, [(_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.load) ? _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "seladdress-list"
  }, [_c('div', {
    staticClass: "address-item"
  }, [_c('table', _vm._l((_vm.addressInfo), function(address, index) {
    return _c('tr', [_c('td', [_c('mu-radio', {
      staticClass: "list-radio floatL",
      class: [address.addressId == _vm.selectAddressId ? 'primary' : ''],
      attrs: {
        "name": "group",
        "nativeValue": address.addressId
      },
      on: {
        "change": function($event) {
          return _vm.selectAddr(address.addressId)
        }
      },
      model: {
        value: (_vm.selectAddressId),
        callback: function($$v) {
          _vm.selectAddressId = $$v
        },
        expression: "selectAddressId"
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "user-box",
      on: {
        "click": function($event) {
          return _vm.selectAddr(address.addressId)
        }
      }
    }, [_c('p', {
      staticClass: "address"
    }, [(address.isDefault == '1') ? _c('label', {
      staticClass: "orange"
    }, [_vm._v("[默认地址]")]) : _vm._e(), _vm._v(_vm._s(address.province) + "  " + _vm._s(address.city) + "  " + _vm._s(address.area) + "  " + _vm._s(address.address))]), _vm._v(" "), _c('p', {
      staticClass: "user"
    }, [_c('label', [_vm._v(_vm._s(address.consignee))]), _c('label', {
      staticClass: "fr"
    }, [_vm._v(_vm._s(address.mobile))])])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "operate",
      on: {
        "click": function($event) {
          return _vm.editAddress(address.addressId)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/images/icon_edit.png"
      }
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "addaddr",
    on: {
      "click": _vm.add
    }
  }, [_vm._v("\n\t\t\t新增收货地址\n\t\t\t"), _c('img', {
    staticClass: "fr",
    attrs: {
      "src": "/static/images/ic_add_address_3x.png"
    }
  })])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b3eb3e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/cart/selectaddress.vue
// module id = 393
// module chunks = 68